<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayOrigin]="overlayOrigin"
             [cdkConnectedOverlayOpen]="isOpened"
             [cdkConnectedOverlayFlexibleDimensions]="true"
             [cdkConnectedOverlayPush]="true"
             [cdkConnectedOverlayGrowAfterOpen]="true"
             [cdkConnectedOverlayViewportMargin]="10"
             (detach)="connectedOverlayDetach()">
  <div #dialog
       role="tooltip"
       class="dialog-container"
       [class.no-padding]="noPadding">

    @if (contentTemplate) {
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</ng-template>
